var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"download-link",attrs:{"src":"https://qiniufile.mddcloud.com.cn/static/download/download-tip_vi.png?v=1"},on:{"click":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }